module.exports = __webpack_public_path__ + "img/27.f012fb44.jpg";